<template>
  <layout-main-inner>
    <div slot="action">
      <el-button
        type="primary"
        :loading="loading"
        @click="edit">保存</el-button>
    </div>
    <layout-card-wrap v-loading="loading">
      <div class="page-wrap">
        <div class="weapp-phone">
          <div
            class="series-item-wrap"
            :class="{ active: headers.visible }"
            @click="() => { toggle('headers'); }">
            <we-header-view :templateId="1" />
          </div>
          <div style="background-color:#F7F7F7;height: 560px;overflow-y: scroll;overflow-x:hidden;">
            <draggable
              v-if="seriesList.length"
              v-model="seriesList"
              :options="dragOptions">
              <template v-for="(item, index) in seriesList">
                <div
                  :key="index"
                  style="cursor: grab;"
                  class="series-item-wrap"
                  :class="{ active: item.visible }"
                  @click="() => { toggle(undefined, index); } ">
                  <we-series-view
                    v-if="item.componentName === 'servicecategoryshow'"
                    :list="item.graphics" />
                  <we-service-org-view
                    v-if="item.componentName === 'servorgshow'"
                    :list="item.graphics" />
                  <we-vendor-view
                    v-if="item.componentName === 'vendorshow'"
                    :list="item.graphics" />
                  <we-info-view v-if="item.componentName === 'info'" />
                  <we-expert-view
                    v-if="item.componentName === 'expertshow'"
                    :list="item.graphics" />
                  <we-goods-view
                    v-if="item.componentName === 'goodsshow'"
                    :list="item.graphics" />
                  <we-circular-view
                    v-if="item.componentName === 'pictureadv' && item.layoutType === 0"
                    :list="item.graphics" />
                  <we-image-view
                    v-if="item.componentName === 'pictureadv' && item.layoutType !== 0"
                    :imageView="item" />
                </div>
              </template>
            </draggable>
          </div>
          <!-- app tab-bar -->
          <div class="series-item-wrap">
            <we-footer-view />
          </div>
          <div style="height: 20px;"></div>
          <el-button
            v-for="item in actionList"
            :key="item.value"
            type="primary"
            size="mini"
            style="margin:0px 0 10px 5px"
            @click="addSeries(item.value)">{{ item.label }}</el-button>
        </div>
        <div class="setting-wrap">
          <we-header
            v-show="headers.visible"
            ref="header"
            v-model="headers" />
          <template v-for="(item, index) in seriesList">
            <template
              v-if="item.componentName === 'pictureadv' && item.layoutType === 0 ">
              <we-circular
                v-show="item.visible"
                :ref="'series_' + index"
                :key="index"
                v-model="seriesList[index]"
                :index="index"
                @deleteItem="deleteItem" />
            </template>
            <template v-if="item.componentName === 'servicecategoryshow'">
              <we-series
                v-show="item.visible"
                :key="index"
                :ref="'series_' + index"
                v-model="seriesList[index]"
                :index="index"
                @deleteItem="deleteItem" />
            </template>
            <template v-if="item.componentName === 'servorgshow'">
              <we-service-org
                v-show="item.visible"
                :key="index"
                :ref="'series_' + index"
                v-model="seriesList[index]"
                :index="index"
                @deleteItem="deleteItem" />
            </template>
            <template v-if="item.componentName === 'vendorshow'">
              <we-vendor
                v-show="item.visible"
                :key="index"
                :ref="'series_' + index"
                v-model="seriesList[index]"
                :index="index"
                @deleteItem="deleteItem" />
            </template>
            <template v-if="item.componentName === 'info'">
              <we-info
                v-show="item.visible"
                :key="index"
                :ref="'series_' + index"
                :index="index"
                @deleteItem="deleteItem" />
            </template>
            <template v-if="item.componentName === 'goodsshow'">
              <we-goods
                v-show="item.visible"
                :key="index"
                :ref="'series_' + index"
                :index="index"
                @deleteItem="deleteItem" />
            </template>
            <template v-if="item.componentName === 'expertshow'">
              <we-expert
                v-show="item.visible"
                :key="index"
                :ref="'series_' + index"
                :index="index"
                @deleteItem="deleteItem" />
            </template>
            <template
              v-if="item.componentName === 'pictureadv' && item.layoutType !== 0">
              <we-image
                v-show="item.visible"
                :ref="'series_' + index"
                :key="index"
                v-model="seriesList[index]"
                :index="index"
                @deleteItem="deleteItem" />
            </template>
          </template>
        </div>
      </div>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import './busi/index.styl'
import { actionList, componentList, getSeries } from './index'
export default {
  name: 'GatewayEdit',
  components: { ...componentList },
  data() {
    return {
      actionList,
      loading: false,
      dragOptions: { animation: 0, disabled: false, group: 'description', ghostClass: 'ghost' },
      headers: { visible: false, pageName: '', pageTitle: '', status: 0 },
      seriesList: []
    }
  },
  mounted() {
    console.log(this.$route.query)
    this.vendorId = this.$route.query.vendorId
    if (this.$route.query.portalPageId) {
      this.portalPageId = this.$route.query.portalPageId
      this.getportalpage()
    }
    this.toggle('headers')
  },
  methods: {
    deleteItem(index) {
      console.log('deleteItem', index)
      this.seriesList.splice(index, 1)
    },
    toggle(ref, index) {
      console.log('toggle')
      if (index !== undefined) {
        this.headers.visible = false
        this.seriesList.forEach((i, idx) => {
          i.visible = idx === index
        })
        this.seriesList = this.seriesList.map((i, idx) => ({ ...i, visible: idx === index }))
        // this.$set(this, 'seriesList', this.seriesList)
      } else {
        this.headers.visible = false
        this.seriesList.forEach(i => {
          i.visible = false
        })
        this[ref].visible = true
      }
    },
    addSeries(type) {
      this.seriesList.push(getSeries[type]())
    },
    edit() {
      const submitList = [this.$refs.header.submit()]
      this.seriesList.forEach((i, idx) => {
        const ref = 'series_' + idx
        submitList.push(this.$refs[ref][0].submit())
      })
      Promise.all(submitList)
        .then(() => {
          const list = this.seriesList.map(i => {
            if (i.componentName === 'pictureadv') {
              return {
                componentName: 'pictureadv',
                data: {
                  layoutType: i.layoutType,
                  styleType: i.styleType,
                  graphics: i.graphics.map(s => {
                    const image = s.image.map(img => img.url).join(',')
                    return { ...s, image }
                  })
                }
              }
            }
            if (i.componentName === 'servicecategoryshow' || i.componentName === 'servorgshow') {
              return {
                componentName: i.componentName,
                data: {
                  layoutType: i.layoutType,
                  data: i.graphics.map(s => ({ id: s.id }))
                }
              }
            }
            if (i.componentName === 'vendorshow') {
              return {
                componentName: i.componentName,
                data: {
                  vendors: i.graphics.map(s => ({ vendorId: s.vendorId }))
                }
              }
            }
            return i
          })
          const headers = this.headers
          const postData = {
            pageName: headers.pageName,
            pageTitle: headers.pageTitle,
            status: headers.status,
            portalPageId: this.portalPageId || null,
            wxappPageId: this.wxappPageId || null,
            vendorId: this.vendorId,
            vBody: [...list]
          }
          console.log(postData)
          this.loading = true
          const dispatch = this.portalPageId ? 'updateportalpage' : 'addportalpage'
          this.$store.dispatch(`gateway/${dispatch}`, {
            payload: { ...postData },
            success: () => {
              this.loading = false
              this.$message.success('更新成功')
              if (!this.portalPageId) {
                this.$router.go(-1)
              }
            },
            fail: () => {
              this.loading = false
            }
          })
        })
        .catch(err => {
          console.log(err)
          const error = JSON.parse(err.message)
          if (error.pop) {
            this.toggle(error.pop)
          }
          if (Number.isInteger(error.index)) {
            this.toggle(undefined, error.index)
          }
        })
    },
    getportalpage() {
      this.loading = true
      this.$store.dispatch('gateway/getportalpage', {
        payload: { vendorId: this.vendorId, portalPageId: this.portalPageId },
        success: res => {
          this.loading = false
          const data = res.data
          this.wxappPageId = data.wxappPageId
          this.headers = { ...this.headers, pageName: data.pageName, pageTitle: data.pageTitle, status: data.status }
          const list = data.vBody.map(i => {
            if (i.componentName === 'pictureadv') {
              return {
                visible: false,
                componentName: 'pictureadv',
                layoutType: i.data.layoutType,
                styleType: i.data.styleType,
                graphics: i.data.graphics.map(s => {
                  const image = s.image.split(',').map(url => ({ url }))
                  return { ...s, image }
                })
              }
            }
            if (['servicecategoryshow', 'servorgshow', 'goodsshow', 'expertshow'].includes(i.componentName)) {
              return { visible: false, componentName: i.componentName, layoutType: i.data.layoutType, graphics: i.data.data }
            }
            if (i.componentName === 'vendorshow') {
              return { visible: false, componentName: i.componentName, graphics: i.data.vendors }
            }
            return i
          })
          this.seriesList.push(...list)
          setTimeout(() => {
            this.toggle('headers')
          }, 20)
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="stylus">
.page-wrap {
  display: flex;
}

.setting-wrap {
  min-width: 0
  flex: 1;
  padding-left: 24px;
}

.weapp-phone {
  flex: 0 0 375px;
  width: 375px;
  border: 1px solid #f0f2f5;

  img {
    width: 100%;
    display: inline-block;
    vertical-align: top;
  }

  .active {
    position: relative;

    &::after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      top: -50%;
      right: -50%;
      bottom: -50%;
      left: -50%;
      border: 2px dashed red;
      -webkit-transform: scale(0.5);
      transform: scale(0.5);
    }
  }

  .series-item-wrap {
    position: relative;
  }

  .series-item-wrap + .series-item-wrap {
    margin-top: 5px;
  }
}
</style>
